import type { Logo as ILogo } from "~/components/header/types"
import Image from "~/components/ui/Image"

interface Props {
    logo?: ILogo
    isHome: boolean
}

export default function Logo({ isHome, logo }: Props) {
    if (!logo) return null

    const LogoComponent = isHome ? 'h1' : 'div'

    return (
        <LogoComponent data-prerender className='flex-none w-fit'>
            <a href='/' aria-label={logo.alt ?? 'Logo da loja Miess'} className='block'>
                <Image
                    src={logo.src}
                    alt={logo.alt ?? 'Logo da loja Miess'}
                    width={logo.width}
                    height={logo.height}
                    loading='eager'
                />
            </a>
        </LogoComponent>
    )
}
